module.exports = __webpack_public_path__ + "img/5k.635a6415.jpg";